import React from "react";
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  TabContent, TabPane, Nav, NavItem, NavLink, CardTitle, CardText, Table,
  ListGroup, ListGroupItem
} from 'reactstrap';
import moment from 'moment';

// import { AsyncSelectField, DateTimeField, DateField, TextField, NumberField, DisplayJson, Label } from "../../components/FormControl";
// import CustomerPOProductFormCtrl from '../../containers/CustomerPO/CustomerPO.ProductForm';
// import withDraggablePopup from '../../components/withDraggablePopup';
// import Popup from "../../components/Popup";

// class MobileView extends React.Component {
//   render() {
//     const { key, data, dataKey, index, saveData, selected, onClickGroup } = this.props;
//     return (
//       <div>
//         <span className="h3"> {`Date: ${moment(data[0].PODate, "DD/MM/YYYY HH:mm:ss").format('DD/MM/YYYY')}`}</span>
//         <Table onClick={() => onClickGroup(dataKey, () => this.setState({}))}>
//           <thead>
//             <tr>
//               <th style={{ width: '60%' }}><Label>Product</Label></th>
//               <th style={{ width: '20%', whiteSpace: 'nowrap' }}><Label>Unit Price</Label></th>
//               <th style={{ width: '20%' }}><Label>QTY</Label></th>
//             </tr>
//           </thead>
//           <tbody style={{ backgroundColor: selected[dataKey] ? 'skyblue' : 'transparent' }}>
//             {data.map(obj => {
//               return (
//                 <tr>
//                   <td style={{ width: '60%' }}>
//                     <div>{`${obj.PriceModeDesc ? obj.PriceModeDesc + " - " : ''}${obj.ProductCode}`}</div>
//                     <div>{obj.ProductShortDesc}</div>
//                     {obj.Remark && <div>{`Remark: ${obj.Remark}`}</div>}
//                   </td>
//                   <td style={{ width: '20%' }} >{`$${obj.UnitPrice} /${obj.PriceUnit}`}</td>
//                   <td style={{ width: '20%' }}>{`${obj.Quantity} ${obj.PurchaseUnit}`}</td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </Table>
//       </div>
//     );
//   }
// }

export default class MobileGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1
    }

    // this.dataFrom = Math.max(this.state.page * props.pageSize - props.pageSize, 0);
    // this.dataTo = this.state.page * props.pageSize;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { pageSize } = this.props;
    if (this.state.page !== nextState.page) {
      this.dataFrom = Math.max(nextState.page * pageSize - pageSize, 0);
      this.dataTo = nextState.page * pageSize;
    }

    return true;
  }

  getHeader = colObj => {
    var header = null;

    if (colObj.Header) {
      if (typeof colObj.Header == 'string')
        header = colObj.Header;
      else if (typeof colObj.Header == 'object')
        header = colObj.Header.props.children;
    }
    return header;
  }

  onClick = index => {
    const { onClick, data, callbackType } = this.props;
    if (!onClick)
      return;

    switch (callbackType) {
      case 'CustomerPriceInquiry':
        onClick(data[index])
        break;
      case 'RemarkOption':
        onClick(data[index])
        break;
      default:
        onClick(index);
        break;
    }
  }

  isInRange = (index, From, To )=> {
    var inRange = false;

    if (index >= From && index < To)
      inRange = true;

    return inRange;

  }

  render() {
    const { columns, data, pageSize, values } = this.props;

    
    var dataFrom = Math.max(this.state.page * pageSize - pageSize, 0);
    var dataTo = this.state.page * pageSize;
    var maxPage = Math.ceil((data.length || 1) / pageSize);
    //sconsole.log("pageSize", pageSize)
    return (
      <div className="inlineEdit my-3">
        <ListGroup>
          {data.map((dataObj, index) => {
            if (this.isInRange(index,dataFrom,dataTo))
              return (<ListGroupItem key={index} onClick={() => this.onClick(index)}>
                <Row>
                  <Col xs={1} className="vertial-align" style={{ padding: 0 }}>
                    {index + 1}
                  </Col>
                  <Col>
                    {columns.map((col, colIndex) => {
                      var header = this.getHeader(col);
                      var data = dataObj[col.accessor];
                      var validDate = moment(data, 'DD/MM/YYYY HH:mm:ss', true).isValid();
                      if (validDate) {
                        data = moment(data, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
                        if (data.startsWith('01/01/0001'))
                          return;
                      }
                      if (col.accessor && dataObj[col.accessor])
                        return <Row key={colIndex}>{`${header}: ${data}`}</Row>
                    })}
                  </Col>
                </Row>
              </ListGroupItem>)
          })}
        </ListGroup>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className="btn-group">
            <div className="btn btn-default" style={{ width: 36 }}>
              <i hidden={this.state.page == 1} className="fa fa-angle-left fa-2x" title="Previous"
                onClick={() => this.setState({ page: this.state.page - 1 })}></i>
            </div>
            <div className="vertial-align">{this.props.PageText || "Page"} {this.state.page}/{maxPage}</div>
            <div className="btn btn-default" style={{ width: 36 }}>
              <i hidden={this.state.page == maxPage} className="fa fa-angle-right fa-2x" title="Next"
                onClick={() => this.setState({ page: this.state.page + 1 })}></i>
            </div>
          </div>
        </div>

      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileGrid.js